import { Injectable, inject } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable, fromEvent } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private readonly authService = inject(AuthService);
  private readonly logger = inject(LoggerService);
  private socket: Socket | null = null;

  public connect(): void {
    const token = this.authService.getToken();
    if (!token || this.socket?.connected) {
      return;
    }

    this.socket = this.createSocket(token);

    this.socket.on('connect', () => {
      this.logger.debug('[ws] Connected');
    });

    this.socket.on('disconnect', () => {
      this.logger.debug('[ws] Disconnected');
    });

    this.socket.on('connect_error', (err) => {
      this.logger.warn('[ws] Connection error', err.message);
    });
  }

  private createSocket(token: string): Socket {
    return io(environment.wsUrl, {
      auth: { token },
      transports: ['websocket', 'polling'],
    });
  }

  public disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  public on<T>(event: string): Observable<T> {
    if (!this.socket) {
      throw new Error('Socket not connected');
    }
    return fromEvent<T>(this.socket, event);
  }

  public emit(event: string, data: unknown): void {
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }
}
